import React from 'react';
import ModalBasic from "../../pages/component/ModalBasic";
import TextInput from "../UIComponent/TextInput";
import DropdownSelect from "../dropdown/Dropdown";
import Validation from "../../utils/validation/ValidationText"

export default function EditViewNewBooking(props) {
    return (
        <>
            <ModalBasic
                id="upload-booking-reports"
                className="upload-booking-reports"
                modalOpen={props.setEditViewNewBooking}
                setModalOpen={props.setOpenModal}
                title="Edit Booking"
            >
                <div className="bg-white p-8 rounded-lg shadow-lg">
                    {/* Form Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* First Name with Dropdown */}

                        {/* Last Name */}
                        <div>
                            <h2 className="theme-label">
                                Attendee Name <span className="text-[#c00000]">*</span>
                            </h2>
                            <TextInput
                                placeholder=""
                                type="text"
                                name="attendeeName"
                                value={props.editViewNewBooking.attendeeName}
                                handleChange={(e) => props.handlechangeForEdit(e)}
                                onBlur={(e) => props.validate("attendeeName")}
                            />
                            <Validation error={props.validState.error.attendeeName} />
                        </div>


                        {/* Contact Number */}
                        <div>
                            <h2 className="theme-label">
                                Contact Number <span className="text-[#c00000]">*</span>
                            </h2>
                            <TextInput
                                placeholder=""
                                type="number"
                                name="contactNo"
                                value={props.editViewNewBooking.contactNo}
                                handleChange={(e) => props.handlechangeForEdit(e)}
                                onBlur={(e) => props.validate("contactNo")}
                            />
                            <Validation error={props.validState.error.contactNo} />
                        </div>


                        {/* Company Name */}
                        <div>
                            <h2 className="theme-label">
                                Company Name <span className="text-[#c00000]">*</span>
                            </h2>
                            <TextInput
                                placeholder=""
                                type="text"
                                name="companyName"
                                value={props.editViewNewBooking.companyName}
                                handleChange={(e) => props.handlechangeForEdit(e)}
                                onBlur={(e) => props.validate("companyName")}
                            />
                            <Validation error={props.validState.error.companyName} />
                        </div>


                        {/* Company UEN */}
                        <div>
                            <h2 className="theme-label">
                                Email Address <span className="text-[#c00000]">*</span>
                            </h2>
                            <TextInput
                                placeholder=""
                                type="text"
                                name="emailAddress"
                                value={props.editViewNewBooking.emailAddress}
                                handleChange={(e) => props.handlechangeForEdit(e)}
                                onBlur={(e) => props.validate("emailAddress")}

                            />
                            <Validation error={props.validState.error.emailAddress} />

                        </div>
                    </div>

                    {/* Update Button */}
                    <div className="mt-10 flex justify-end">
                        <button className="w-32 px-7 py-3 text-xl bg-red-600 hover:bg-red-700 text-white font-semibold rounded"
                            onClick={() => props.updateNewBookingDetailsById(props.editViewNewBooking.bookingAttendeeInformationId)}>
                            Update
                        </button>
                    </div>
                </div>
            </ModalBasic>
        </>
    );
}
